const constants = {
  data () {
    return {
      app: {
      }
    }
  },
	SUPER_ADMIN: 'Super Admin',
  ADMINISTRATOR: 'Administrator',
  SUPERVISOR: 'Kantor Pusat',
  OPERATOR: 'Cabang'
}

export default constants
